/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the stopwatch with one click and record laps as you go. It's accurate to a hundredth of a second and keeps counting even in a background tab.`)
};

const es_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia el cronómetro con un clic y registra vueltas sobre la marcha. Es preciso hasta la centésima de segundo y sigue contando incluso en una pestaña en segundo plano.`)
};

const de_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte die Stoppuhr mit einem Klick und erfasse Runden im Verlauf. Sie ist auf die Hundertstelsekunde genau und zählt auch in einem Hintergrund-Tab weiter.`)
};

const nl_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start de stopwatch met één klik en noteer rondetijden terwijl je bezig bent. Hij is nauwkeurig tot op een honderdste seconde en blijft doortellen, ook in een tabblad op de achtergrond.`)
};

const fr_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrez le chronomètre en un clic et enregistrez les tours au fur et à mesure. Il est précis au centième de seconde et continue de compter même dans un onglet en arrière-plan.`)
};

const it_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia il cronometro con un clic e registra i giri man mano. È preciso al centesimo di secondo e continua a contare anche in una scheda in background.`)
};

const pt_br2_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie o cronômetro com um clique e registre voltas conforme avança. Ele tem precisão de centésimos de segundo e continua contando mesmo em uma aba em segundo plano.`)
};

const pt_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie o cronómetro com um clique e registe voltas à medida que avança. Tem precisão de um centésimo de segundo e continua a contar mesmo num separador em segundo plano.`)
};

const ja_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワンクリックでストップウォッチをスタートし、ラップを記録できます。1/100秒単位で正確に計測し、タブがバックグラウンドでもカウントを続けます。`)
};

const zh_timer_stopwatch_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一键启动秒表，随时记录圈数。精确到百分之一秒，即使在后台标签页也能持续计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_intro", locale)
	if (locale === "en") return en_timer_stopwatch_intro(inputs)
	if (locale === "es") return es_timer_stopwatch_intro(inputs)
	if (locale === "de") return de_timer_stopwatch_intro(inputs)
	if (locale === "nl") return nl_timer_stopwatch_intro(inputs)
	if (locale === "fr") return fr_timer_stopwatch_intro(inputs)
	if (locale === "it") return it_timer_stopwatch_intro(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_intro(inputs)
	if (locale === "pt") return pt_timer_stopwatch_intro(inputs)
	if (locale === "ja") return ja_timer_stopwatch_intro(inputs)
	return zh_timer_stopwatch_intro(inputs)
};